import {ArrayCell} from '~/components/advanced_table/components/cells/array_cell'
import {UserEnvironmentStatusCell} from '~/components/advanced_table/components/cells/user_environment_status_cell'
import {ftime} from '@eitje/utils'
import {t} from '~/initializers/i18n'

export const COLUMNS = [
	{
		id: 'environment',
		accessorFn: ({environment}) => environment.naam,
	},
	{
		id: 'user_environment_status',
		cell: UserEnvironmentStatusCell,
		accessorFn: ({environment, user}) => {
			const {status, id} = environment
			// environment can be inactive and user can be out of service at the same time. Inactive has precedence over out of service.
			if (status === 'inactive') return status
			if (user.deleted_environment_ids.includes(id)) return 'out_of_service'
			return status
		},
	},
	{
		id: 'roles',
		accessorFn: ({environment, user}) => user.roles[environment.id]?.map(role => t(`roles.${role}`)),
		cell: ArrayCell,
	},
	{
		id: 'date',
		tooltip: true,
		popout: {
			title: 'tooltips.date.title',
			body: 'tooltips.date.body',
		},
		accessorFn: ({environment, user}) => {
			const {id} = environment
			const {environment_users, deleted_clients} = user
			const environmentUser = environment_users.find(user => user.environment_id === id)
			if (environmentUser) return environmentUser.created_at
			const deletedClient = deleted_clients?.find(client => client.environment_id === id)
			return deletedClient?.created_at
		},
		cell: ({value}) => ftime(value, 'dayMonthYear'),
	},
]
